
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, of, tap, throwError } from 'rxjs';
import { ApiService } from '../../core/_services/api/api.service';
import { BaseApi } from '../../shared/_models/base-api';

@Injectable({
  providedIn: 'root',
})

export class CompanySettingServices extends BaseApi {
  constructor(private _apiService: ApiService) {
    super();
  }

  private timeZoneSubject = new BehaviorSubject<any[] | null>(null);
  private generalCurrencySubject = new BehaviorSubject<any[] | null>(null);

  public generalTabInfo(id: any): Observable<any[]> {
    const userId = localStorage.getItem('userId');

    if (!userId) {
      // You can handle it here however you'd like:
      return throwError(() => new Error('User ID not available'));
    }

    return this._apiService
      .get(`CompanySettings/GetCompanySetup?co_id=${id}&user_id=${userId}`)
      .pipe(map((response: any) => response));
  }

  public generalcurrency(): Observable<any[]> {
    if (this.generalCurrencySubject.value) {
      return of(this.generalCurrencySubject.value);
    }

    return this._apiService.get(`Currency`).pipe(
      map((response: any) => response),
      tap((currencies: any[]) => {
        this.generalCurrencySubject.next(currencies);
      })
    );
  }

  public getTimeZone(): Observable<any[]> {
    if (this.timeZoneSubject.value) {
      return of(this.timeZoneSubject.value);
    }
    return this._apiService.get(`CompanySettings/GetAllTimeZone`).pipe(
      map((response: any) => response),
      tap((timeZones: any[]) => {
        this.timeZoneSubject.next(timeZones);
      })
    );

  }

  public saveGeneralInfo(reqObj: any): Observable<any> {
    return this._apiService.post('CompanySettings/Multiple', reqObj);
  }
  public getPeriodDiff(): Observable<any[]> {
    return this._apiService
      .get(`CompanySettings/GetAllReportingPeriodFrequencies`)
      .pipe(map((response: any) => response));
  }

  public getEvaluation(id: any): Observable<any[]> {
    return this._apiService
      .get(`CompanySettings/GetAllEvaluationRanges${id}`)
      .pipe(map((response: any) => response));
  }

  public saveEvaluationTab(reqObj: any): Observable<any[]> {
    return this._apiService
      .post(`CompanySettings/EvaluationRangesMultiple`, reqObj)
      .pipe(map((response: any) => response));
  }

  public deleteEvaluationrec(id: any): Observable<any[]> {
    return this._apiService
      .post(`CompanySettings/DeleteEvaluationRange`, id)
      .pipe(map((response: any) => response));
  }

}

